import { useMemo } from 'react';
import { useMessages } from '../../store/messages';
import { useObservations } from '../../store/observations';
import DebriefingSection from '../layout/debriefing-section';
import PlanAnalyzer from '../plots/plan-analyzer';
import { scenarioLabels } from '../plots/scenario-labels';

const PlanAnalyzerSection = ({ groupId, sessionId }) => {
  const { find, observations } = useObservations(({ observations, find }) => ({
    observations,
    find,
  }));

  const t = useMessages(({ print }) => print);

  const sessionObservations = useMemo(
    () => find(`/sessions/${sessionId}/**/groups/**/plans/executive`),
    [find, observations, sessionId, groupId]
  );

  const groupObservation = sessionObservations.find(
    obs => obs.groupId === groupId
  );

  return (
    <DebriefingSection
      title={t('slide-6-title', { team: groupId || '' })}
      data={`${scenarioLabels[
        groupObservation?.scenario
      ]?.toUpperCase()} - AcR: ${(
        Number(groupObservation?.acceptanceRate) * 100
      ).toFixed(2)}%`}
      subTitle={t('slide-6-tooltip')}
    >
      <PlanAnalyzer sessionId={sessionId} groupId={groupId} />
    </DebriefingSection>
  );
};
export default PlanAnalyzerSection;
